module.exports = __webpack_public_path__ + "r-v3/img/ml_42_01.28a75f56.jpg";